import { ProgramDocument } from '../../models';
import { ProgramDocumentQueries } from '../../models/queries-type';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramDocuments: (
  fetchContext: FetchContext, 
  programDocumentQueries: ProgramDocumentQueries,
  accessToken?: string) => Promise<ProgramDocument[]> = (fetchContext, programDocumentQueries, accessToken) => {
  const searchParams = new URLSearchParams();
  searchParams.append('documentGroupTypeCode', programDocumentQueries.type);

  const url = `${fetchContext.baseUrl}/api/program-documents${
    searchParams.size > 0 ? `?${searchParams}` : ''
  }`;

  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<ProgramDocument[]>(fetchContext.errorStore, response, 'get program documents'));
};
